import React from "react";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ModalConfirmacion from "./ModalConfirmacion";
import Utils from "../../../../utils/Utils";
import OrderStates from "../../../../utils/OrderStates";
import { ESTADO_PROCESO } from "../../../../config/constants";

/**
 * Confirmación para forzar como preparado un pedido colgado de Nave 2
 */
const ModalForzarPedidoN2 = ({ pedido, loading, onHide, onConfirm }) => (
    <ModalConfirmacion
        show={Boolean(pedido)}
        onHide={onHide}
        onConfirm={onConfirm}
        loading={loading}
        title="Forzar pedido como preparado"
        titleMobile="Forzar pedido"
        text="El pedido se marcará como <strong>preparado en nave 2</strong> y desaparecerá de la lista, sin avisar al preparador de nave 1. Si te equivocas, puedes devolverlo con <strong>Recuperar pedido</strong>."
        detalles={pedido ? [
            { label: "Pedido", value: pedido.num },
            { label: "Tipo", value: Utils.toCapitalize(pedido.type) },
            { label: "Cliente", value: Utils.toCapitalize(pedido.customer) },
            { label: "Estado", value: OrderStates.getStateN2(pedido.state) },
            { label: "Prep. N1", value: pedido.preparerN1 || ESTADO_PROCESO.SIN_PREPARADOR }
        ] : []}
        confirmLabel="Forzar preparado"
        confirmLabelMobile="Forzar"
        icon={DoneAllIcon}
        confirmIcon={DoneAllIcon}
    />
);

export default ModalForzarPedidoN2;
